import { IState } from 'legacy/lut/store'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { refreshActionRequest } from '../actions/refreshActionRequestAction'
import { actionApi } from '../api/actionApi'
import { processesProgressApi } from '../api/processesProgressApi'
import { progressApi } from '../api/progressApi'
import { requestApi } from '../api/requestApi'

listenerMiddleware.startListening({
  actionCreator: refreshActionRequest,
  effect: async (_action, listenerEffectAPI) => {
    const { dispatch, getState } = listenerEffectAPI
    const state = getState() as IState
    const progressData = state.onboarding.progressData

    const requestId = state.onboarding.requestData.data.EntryId
    const requestIdAsString = requestId?.toString()
    const parentId = state.onboarding.requestData.data.Parent?.toString()
    const partnerId = progressData.profilingProgressData.meta?.arg?.['partnerId']
    const lrProgressMeta = progressData.lrProgressData.meta?.arg
    const contractSignatureProgressMeta = progressData.contractSignatureProgressData.meta?.arg

    if (requestId) {
      dispatch(actionApi.getExecutableTransitions({ requestId }))
    }

    if (partnerId && requestId) {
      dispatch(progressApi.getProfilingProgress({ partnerId, requestId }))
    }

    if (requestIdAsString) {
      dispatch(requestApi.getRequestData({ requestId: requestIdAsString }))
      dispatch(actionApi.getActions({ requestId: requestIdAsString }))
      dispatch(processesProgressApi.getProcessesProgress({ requestId: requestIdAsString }))
    }

    if (parentId) {
      dispatch(actionApi.getParentActions({ requestId: parentId }))
    }

    if (lrProgressMeta?.['requestId']) {
      dispatch(progressApi.getLRProgress({ requestId: lrProgressMeta?.['requestId'] }))
    }
    if (contractSignatureProgressMeta?.['requestId']) {
      dispatch(
        progressApi.getContractSignatureProgress({
          requestId: contractSignatureProgressMeta?.['requestId'],
        })
      )
    }
  },
})
